
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.34 15a3 3 0 100-6 3 3 0 000 6z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M23.348 11.184c-1.24-1.918-2.85-3.547-4.653-4.712-1.996-1.29-4.199-1.972-6.37-1.972-1.994 0-3.954.57-5.826 1.693-1.91 1.145-3.639 2.818-5.141 4.972a1.496 1.496 0 00-.03 1.666c1.238 1.937 2.83 3.569 4.607 4.718 1.999 1.295 4.15 1.951 6.39 1.951 2.189 0 4.396-.676 6.384-1.956 1.802-1.16 3.408-2.796 4.644-4.73a1.51 1.51 0 00-.005-1.63zM12.34 16.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9z","fill":"currentColor"}})])
          )
        }
      }
    